import React, { useCallback, useEffect, useRef } from 'react';
import Layout from '../Layout';
import Header from './Header';
import Body from './Body';
import ProgressPage from '../Progress/ProgressPage';
import { useSocket } from '../../Context/SocketContext';

const SmartNotes = () => {
  const [currentTab, setCurrentTab] = React.useState('notes-tab');
  const [payload, setPayload] = React.useState(null);
  const hasRunRef = useRef(false);

  const socket = useSocket();

  useEffect(() => {
    if (!socket || hasRunRef.current) return;
    hasRunRef.current = true;

    // get query parameter from URL
    const urlParams = new URLSearchParams(window.location.search);
    const associationID = urlParams.get('id');
    const course = urlParams.get('course');

    socket.emit('getSmartNotes', { associationID, course });
    socket.on('processedNotesData', data => {
      setPayload(data);
      socket.emit('retrieveCreditPoints');
      // setPayload(data);
    });

    // process and fetch data from backend
  }, [socket]);

  const headerRenderer = useCallback(() => {
    return <Header setTab={setCurrentTab} currentTab={currentTab} />;
  }, [currentTab]);

  const bodyRenderer = useCallback(() => {
    return <Body currentTab={currentTab} payload={payload} />;
  }, [currentTab, payload]);

  return (
    <>
      {payload ? (
        <Layout
          header={headerRenderer}
          body={bodyRenderer}
          hasGenericFooter={true}
        />
      ) : (
        <ProgressPage
          headerText="Smart Notes"
          subHeadingText="Generating Smart Notes"
          dynamicText={[
            'Analyzing study materials',
            'Sifting through your notes',
            'Phoning a friend...Einstein',
            'Optimizing and refining details',
            'Almost ready...',
          ]}
        />
      )}
    </>
  );
};

export default SmartNotes;
